var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-search-container"},[(_vm.shouldRender)?_c('button',{staticClass:"btn live-search-btn"},[_c('b-checkbox',{staticClass:"checkbox",attrs:{"disabled":_vm.disabled},model:{value:(_vm.liveSearch),callback:function ($$v) {_vm.liveSearch=$$v},expression:"liveSearch"}}),_c('span',[_vm._v(" Search as map moves ")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }